var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('keep-alive',{attrs:{"include":_setup.cacheViews,"max":10}},[_c('router-view',{key:_setup.routeCacheKey})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }